<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Processando...</p>
  </ngx-spinner>
  <section class="d-flex flex-column p-4">
    <div class="mb-3">
      <h3>Obrigações Acessórias</h3>
    </div>

    <mat-card>
      <mat-card-title>
        <div class="icone-circulo">
          <i class="bi bi-journal-text icone-titulo"></i>
        </div>
        <span class="texto-titulo">Relatórios Disponíveis:</span>
      </mat-card-title>

      <mat-card-content>
        <div>
          <span>Omissões</span>
          <button mat-raised-button class="btn-imprimir" (click)="emitirOmissoes()">
            <i class="bi bi-printer"></i> Emitir
          </button>
        </div>

        <div>
          <span>Entregas de Arquivos - DeSTDA</span>
          <button mat-raised-button class="btn-imprimir" (click)="emitirEntregasArquivos()">
            <i class="bi bi-printer"></i> Emitir
          </button>
        </div>

      </mat-card-content>
    </mat-card>

  </section>
